import classNames from 'classnames';
import s from './IconButton.module.scss';
import { ButtonHTMLAttributes, ForwardedRef, MouseEvent, ReactNode, forwardRef } from 'react';

interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'color'> {
  className?: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  children: ReactNode;
  disabled?: boolean;
  size?: 'xs' | 's' | 'm' | 'l';
  color?: 'red' | 'black' | 'green' | 'gray';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref: ForwardedRef<HTMLButtonElement>) => {
    const { className, children, disabled, onClick, color, size = 'm', type = 'button', ...rest } = props;

    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled}
        onClick={onClick}
        className={classNames(s.IconButton, {}, [className, s[color], s[size]])}
        {...rest}
      >
        {children}
      </button>
    );
  },
);

IconButton.displayName = 'IconButton';
